import { useSelector } from 'react-redux';
import { getHeaderName } from '../../store/global/selectors';
import OwnershipStatusLabel from './labels/OwnershipStatusLabel';


export default function DrawerHeader({ name, item, className }) {

    const headerName = useSelector(getHeaderName);


    return (
        <span className={className}>{headerName != '' ? headerName : name}
        </span>
    )

}